<template>
<div>
	<div class="page-header">
		<h1><lang labelKey="HEADER_ACCOUNT"></lang></h1>
	</div>

    <div class="columns">

        <div class="col-main">

			<form @submit.prevent="validateBeforeSubmit">

				<tabs type="boxed" size="normal">

					<tab-item label="Basis Info">

						<div class="control is-horizontal" v-if="userRole != 'Kundenbetreuer'">
							<div class="control-label">
								<label-name labelKey="PRODUCT-UPLOAD_FILE_BOX"></label-name>
							</div>
							<div class="control">

								<vue-dropzone
									ref="vueDropzone"
									id="vueDropzone"
									url= "fileProcessing/upload?preset=person"
									:maxFiles="1"
									:thumbnailWidth="100"
									:thumbnailHeight="100"
									acceptedFiles= ".jpg,.jpeg,.png,.gif"
									:dictDefaultMessage="`<i class='fa fa-cloud-upload'></i>` + $t('USER_ACCOUNT-UPLOAD_AVATAR')"
									v-on:vdropzone-removed-file="dzAvatarRemoveFile"
									v-on:vdropzone-mounted="dzAvatarInit"
									v-on:vdropzone-success="dzAvatarSuccess">
								</vue-dropzone>

							</div>
						</div>

						<div class="control is-horizontal">
							<div class="control-label">
								<label-name labelKey="ACCOUNT_USERNAME"></label-name>
							</div>
							<div class="control">
								<input id="ACCOUNT_USERNAME" class="input is-medium" type="text" :placeholder="$t('ACCOUNT_USERNAME')" v-model.trim="user.username" disabled>
							</div>
						</div>

						<div class="control is-horizontal">
							<div class="control-label">
								<label-name labelKey="ACCOUNT_FIRSTNAME"></label-name>
							</div>
							<div class="control">
								<input id="ACCOUNT_FIRSTNAME" class="input is-medium" type="text" placeholder="Vorname" v-model.trim="user.person.firstname" :readOnly="isReadOnly">
							</div>
						</div>

		                <div class="control is-horizontal">
							<div class="control-label">
								<label-name labelKey="ACCOUNT_LASTNAME"></label-name>
							</div>
							<div class="control">
								<input id="ACCOUNT_LASTNAME" class="input is-medium" type="text" placeholder="Nachname" v-model.trim="user.person.lastname" :readOnly="isReadOnly">
							</div>
						</div>

		                <div class="control is-horizontal">
							<div class="control-label">
								<label-name labelKey="ACCOUNT_EMAIL"></label-name>
							</div>
							<div class="control has-icon has-icon-right">
								<input id="ACCOUNT_EMAIL" name="email" type="email" placeholder="Email" v-model.trim="user.email" class="input is-medium" :readOnly="isReadOnly">
							</div>
						</div>

						<br />
						<br />

						<template v-if="userRole != 'Industriepartner' && userRole != 'Kundenbetreuer'">

							<div class="control is-horizontal">
								<div class="control-label">
									<label-name labelKey="ACCOUNT_PASSWORD"></label-name>
								</div>
								<div class="control has-icon has-icon-right">
									<input id="ACCOUNT_PASSWORD" name="password" v-model.trim="pass1" type="password" placeholder="Passwort" class="input is-medium">
								</div>
							</div>

							<div class="control is-horizontal">
								<div class="control-label"></div>
								<div class="control has-icon has-icon-right">
									<input id="ACCOUNT_PASSWORD2" name="password" v-model.trim="pass2" type="password" placeholder="Passwort wiederholen" class="input is-medium">
								</div>
							</div>

						</template>

						<!--
						<div class="control is-horizontal">
							<div class="control-label">
								<label-name labelKey="ACCOUNT_ROLE"></label-name>
							</div>
							<div class="control">
								<span class="select is-medium">
									<select id="ACCOUNT_ROLE" v-model="user.userRole.id">
										<option v-for="option in roleOptions" :value="option.value" selected="user.userRole.id == option.value ? 'selected' : ''">{{ option.text }}</option>
		                            </select>
								</span>
							</div>
						</div>
						-->

					</tab-item>

				</tabs>

			</form>

		</div> <!-- // col-main -->


        <div class="col-aside">

			<div class="sidebox">
				<custom-button name="ACCOUNT_SAVE" type="blue" icon="icon-ak-speichern" :loading="isSaving" :disabled="userRole=='Kundenbetreuer'" @click.native="validateBeforeSubmit"></custom-button>
			</div>

		</div> <!-- // col-aside -->

	</div>

</div>
</template>


<script>
import vue2Dropzone from './utils/dropzoneWrapper'

export default {

	components: {
		vueDropzone: vue2Dropzone,
	},

	data() {
		return {
			isSaving: false,
			pass1: '',
			pass2: '',
			user: null,
		}

	},

	computed: {

		isReadOnly() {

			return this.userRole == 'Kundenbetreuer';

		}

	},


	created() {

		this.user = this.$store.getters.getUser;

	},

	mounted() {


	},

	methods: {

		// dropzone avatar handling
		// ---------------------------------------------------------------------
		dzAvatarInit() {

			if(this.user.person && this.user.person.image != null) {

				var url = this.$config.assets + this.user.person.image.path + '/' + this.user.person.image.filename;
				var mockFile = { id: 'avatar', name: this.user.person.image.filename }

				// add mockFile to our dropzone
				this.$refs.vueDropzone.$children[0].manuallyAddFile(mockFile, url);

			}

		},

		dzAvatarSuccess(file) {

			var result = JSON.parse(file.xhr.response);

			this.user.person.image = {
				filename: result.fileName,
				path: result.dir,
				uploadFilename: file.name
			}

		},

		dzAvatarRemoveFile() {

			this.user.person.image = null;

		},


		validateBeforeSubmit() {

			// validate email
			if(!this.validateEmail(this.user.email)) {
				this.$notify.open({content: this.$t('MSG-ERROR-USER-EMAIL_NOT_VALID'), type: 'warning'});
				return false;
			}

			if(this.pass1) {

				// validate password length
				if(this.pass1.length <= 2) {
					this.$notify.open({content: this.$t('MSG-ERROR-USER-PASSWORD_TOO_SHORT'), type: 'warning'});
					return false;
				}

				/**
				// validate password
				if(!this.validatePassword(this.pass1)) {
					this.$notify.open({content: this.$t('MSG-ERROR-USER-PASSWORD_NOT_ALLOWED'), type: 'warning'});
					return false;
				}
				*/

				// check if passwords match
				if(this.pass1 != this.pass2)
				{
					this.$notify.open({content: this.$t('MSG-ERROR-USER-PASSWORDS_NOT_MATCHING'), type: 'warning'});
					return false;
				}
				else
				{
					this.user.newPassword = this.pass1;
				}

			}

			this.isSaving = true;
			this.submitForm();

        },


		submitForm: function() {

			var self = this;

			this.axios.put(this.$config.api + 'user/'+this.user.id, this.user)
				.then(function(response) {

					// update User Object in localStorage
					localStorage.setItem('user', JSON.stringify(self.user));

					// reflect changes in our store
					self.$store.commit('setUser', self.user);

					if(self.$store.state.currentLang != self.user.language)
					{
						// set the new currentLang in our store
						self.$store.state.currentLang = self.user.language;

						// update labels in case the user changed his language
						self.$store.dispatch('fetchLabels', self.user.language).then(() => {

							self.$i18n.locale = self.user.language;
							self.isSaving = false;

							// show success notify
							self.$notify.success({content: self.$t('MSG-SUCCESS-DATA_SAVE') });

						});

					}

					else
					{
						self.isSaving = false;
						self.$notify.success({content: self.$t('MSG-SUCCESS-DATA_SAVE') });
					}

				})
				.catch(function(error) {
					self.isSaving = false;
					self.$notify.open({content: self.$t('MSG-ERROR-DATA_SAVE') + ': ' + error.message, type: 'danger'});
				});

		}

	}
}
</script>
